export default "## Welcome to Carma, {name}\n\nYour account has been created successfully!\n";